import { useState } from 'react';
import { siteStats, hotKeywords } from '@/mocks/nav';

interface HeroSectionProps {
  onSearch: (keyword: string) => void;
}

export default function HeroSection({ onSearch }: HeroSectionProps) {
  const [value, setValue] = useState('');

  const submit = (keyword: string) => {
    onSearch(keyword.trim());
    setValue(keyword.trim());
  };

  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20and%20amber%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20and%20subtle%20paper%20grain%20texture%2C%20editorial%20poster%20style%2C%20no%20text%2C%20rich%20color%20contrast%2C%20minimal%20modern%20art&width=1600&height=1000&seq=heilia-hero-bg-01&orientation=landscape"
          alt="暖橙色抽象渐变背景，作为黑料导航首屏视觉底图"
          title="黑料导航 首屏背景"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/75"></div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6 md:pb-24 md:pt-40">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur-sm md:text-sm">
          <i className="ri-radar-line text-base text-accent-400" aria-hidden="true"></i>
          已收录 1,286 个入口 · 每日巡检更新
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 sm:text-4xl md:text-6xl">
          黑料导航
          <span className="mt-3 block text-xl font-semibold text-background-100 sm:text-2xl md:mt-4 md:text-3xl">
            全网吃瓜黑料入口，一站直达不迷路
          </span>
        </h1>

        <p className="mt-5 max-w-3xl text-sm leading-relaxed text-background-100/90 md:mt-6 md:text-base">
          汇集全网吃瓜黑料入口，提供直达地址、首页链接与网址导航，一键进入热门爆料站点。
          持续收录最新入口，帮你解决找不到地址、收藏夹太乱的老问题。
        </p>

        <form
          className="mt-8 flex w-full max-w-2xl flex-col items-stretch gap-2 sm:flex-row md:mt-10"
          onSubmit={(e) => {
            e.preventDefault();
            submit(value);
          }}
          role="search"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索入口关键词
          </label>
          <div className="relative flex-1">
            <span className="pointer-events-none absolute left-4 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base" aria-hidden="true"></i>
            </span>
            <input
              id="hero-search"
              type="search"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="输入关键词，如 热搜 / 路透 / 直播回放"
              className="w-full rounded-md border border-background-300/60 bg-background-50 py-3.5 pl-11 pr-4 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30 md:text-base"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
          >
            <i className="ri-compass-3-line" aria-hidden="true"></i>
            搜索入口
          </button>
        </form>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-100/80 md:text-sm">热门搜索：</span>
          {hotKeywords.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => submit(tag)}
              className="whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1 text-xs text-background-50 transition-colors hover:bg-accent-500 hover:text-foreground-950 md:text-sm"
            >
              {tag}
            </button>
          ))}
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-4">
          {siteStats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-4 backdrop-blur-sm md:px-4 md:py-5"
            >
              <dd className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                {item.value}
                <span className="ml-0.5 text-xs font-normal text-background-100/80 md:text-sm">{item.suffix}</span>
              </dd>
              <dt className="mt-1 text-xs text-background-100/80 md:text-sm">{item.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}